import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SquareButtonComponent} from '../square-button/square-button.component';

@Component({
  selector: 'modal-info',
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.scss'],
  imports: [CommonModule, SquareButtonComponent],

  standalone: true
})
export class ModalInfoComponent {

  @Input() showCloseButton: boolean = true;
  @Input() title!: string;
  @Input() show: boolean = false;
  @Input() closeOnBackdropClick: boolean = true;
  @Output() close = new EventEmitter<void>();

  constructor() {
  }

  onBackdropClick(): void {
    if (this.closeOnBackdropClick) {
      this.closeModal();
    }
  }

  closeModal() {
    this.close.emit();
  }
}
